/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FiltersAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconSettings from 'DesignSystem/Svgs/TysiaIconSettings/index'



/** @type {import('Simple/types.js').View} */
export default function FiltersAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/Search/Content/FiltersAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="center"
 type="secondary"
 size="small"
 marginLeft={dtSpaceXs}
 paddingTop={dtSpaceXs}
 paddingBottom={dtSpaceXs}
 onClick={flow.has(fromFlow.normalizePath(viewPath, '../Filters/Content')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, '../Filters/No')) : () => setFlowTo(fromFlow.normalizePath(viewPath, '../Filters/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../Filters/Content'))}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconSettings
{...childProps}
  viewPath={`${viewPath}/TysiaIconSettings`}
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Filters"
/>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}